export const CurrentDate = 'CurrentDate';
export const WithinPastXDays = 'WithinPastXDays';
export const WithinNextXDays = 'WithinNextXDays';
export const BeforeXDays = 'BeforeXDays';
export const AfterXDays = 'AfterXDays';
export const OnOrAfter = 'OnOrAfter';
export const OnOrBefore = 'OnOrBefore';
